import { useMemo } from 'react'
import { useCaseViewContext } from '../context/CaseViewContext'

export const useRequestedMedications = () => {
    const { caseDetails, activeRequest } = useCaseViewContext()

    const requestedMedications = useMemo(() => {
        if (!caseDetails || !activeRequest) return []

        const requestMedications = activeRequest?.medicines || []
        
        if (requestMedications.length === 0) {
            const allRequestMedications = caseDetails?.requests?.flatMap(request => request.medicines || []) || []
            return allRequestMedications
        }

        return requestMedications
    }, [caseDetails, activeRequest])

    return {
        requestedMedications
    }
}
